-<template>
  <aside class="ls-sidebar">
    <dropdown :class="'ls-dropdown ls-user-account'" :width="'100%'">
      <a slot="trigger" href="#" class="ls-ico-user">
        <span class="ls-name">{{ seller.name }}</span>
        ({{ seller.email }})
      </a>
      <nav slot="list" class="ls-dropdown-nav ls-user-menu" aria-hidden="true">
      <a href="#" class="ls-btn-logout" role="combobox" aria-expanded="false" @click="logOut">{{ $t('application.menu_user.logout') }}</a>
    </nav>
    </dropdown>
    <div class="ls-sidebar-inner">
      <nav class="ls-menu" role="navigation">
        <ul role="menu">
          <authorized-link tag="index_contract">
            <li class="ls-overflow-hidden"><router-link :to="{ name: 'contracts'}" class="ls-ico-week" role="menuitem" :title="$t('application.menu.contracts')">{{ $t('application.menu.contracts') }}</router-link></li>
          </authorized-link>
          <authorized-link tag="index_plan">
            <li class="ls-overflow-hidden"><router-link :to="{ name: 'plans'}" class="ls-ico-docs" :title="$t('application.menu.plans')" role="menuitem">{{ $t('application.menu.plans') }}</router-link></li>
          </authorized-link>
          <authorized-link tag="index_customer">
            <li class="ls-overflow-hidden"><router-link :to="{ name: 'customers'}" class="ls-ico-users" :title="$t('application.menu.clients')" role="menuitem">{{ $t('application.menu.clients') }}</router-link></li>
          </authorized-link>
          <authorized-link tag="index_invoice">
            <li class="ls-overflow-hidden"><router-link :to="{ name: 'invoices'}" class="ls-ico-origins" :title="$t('application.menu.invoices')" role="menuitem">{{ $t('application.menu.invoices') }}</router-link></li>
          </authorized-link>
          <authorized-link tag="index_invoice">
            <li class="ls-overflow-hidden"><router-link :to="{ name: 'orders'}" class="ls-ico-shaft-up" :title="$t('application.menu.orders')" role="menuitem">{{ $t('application.menu.orders') }}</router-link></li>
          </authorized-link>

          <authorized-link tag="index_setting">
            <li @click.prevent="dropdownToggle" class="ls-submenu-parent ls-overflow-hidden" :class="{'ls-active': showMenu}" :aria-expanded="showMenu" :aria-hidden="!showMenu">
              <a href="javascript:void(0)" class="ls-ico-cog" :title="$t('application.menu.setup')" role="menuitem">{{ $t('application.menu.setup') }}</a>
              <ul v-if="showMenu" class="ls-submenu" role="menu">
                <authorized-link tag="update_seller">
                  <li class="ls-overflow-hidden"><router-link :to="{ name: 'general'}" :title="$t('application.menu.general_settings')" role="menuitem">{{ $t('application.menu.general_settings') }}</router-link></li>
                </authorized-link>
                <authorized-link tag="index_setting">
                  <li><router-link :to="{ name: 'payment_settings'}" :title="$t('application.menu.payment_settings')" role="menuitem">{{ $t('application.menu.payment_settings') }}</router-link></li>
                  <li><router-link :to="{ name: 'billing_settings'}" :title="$t('application.menu.billing_settings')" role="menuitem">{{ $t('application.menu.billing_settings') }}</router-link></li>
                  <li><router-link :to="{ name: 'webhook_settings'}" :title="$t('application.menu.webhook_settings')" role="menuitem">{{ $t('application.menu.webhook_settings') }}</router-link></li>
                  <li><router-link :to="{ name: 'nfe_settings'}" :title="$t('application.menu.nfe_settings')" role="menuitem">{{ $t('application.menu.nfe_settings') }}</router-link></li>
                </authorized-link>
                <authorized-link tag="index_tax">
                  <li class="ls-overflow-hidden"><router-link :to="{ name: 'taxes' }" :title="$t('application.menu.taxes')" role="menuitem">{{ $t('application.menu.taxes') }}</router-link></li>
                </authorized-link>
                <authorized-link tag="index_user">
                  <li class="ls-overflow-hidden"><router-link :to="{ name: 'users'}" :title="$t('application.menu.general_settings')" role="menuitem">{{ $t('application.menu.users_access') }}</router-link></li>
                </authorized-link>
              </ul>
            </li>
          </authorized-link>
        </ul>
      </nav>
    </div>
    <span class="ls-sidebar-toggle ls-ico-shaft-left" @click="resizeSidebar()"></span>
  </aside>
</template>
<script>
import { mapGetters } from 'vuex'
import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
import { setIsLogged } from 'src/app/pages/auth/vuex/mutations-types'

export default {
  name: 'user-account',
  components: { Dropdown },
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    ...mapGetters(['seller'])
  },
  methods: {
    logOut () {
      this.$store.commit(setIsLogged, false)
      this.$router.push('/auth')
    },
    dropdownToggle () {
      this.showMenu = !this.showMenu
    },
    resizeSidebar () {
      if (document.documentElement.classList.contains('ls-sidebar-toggled')) {
        document.documentElement.classList.remove('ls-sidebar-toggled')
      } else {
        document.documentElement.classList.add('ls-sidebar-toggled')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .ls-user-account {
    padding: 0;
    a {
      padding: 14px 18px;
    }
  }
  .ls-submenu-parent ul {
    height: auto;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// sidebar.vue?15008509